// src/components/email/EmailCampaignList.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import Swal from 'sweetalert2';

function EmailCampaignList() {
  const navigate = useNavigate();
  const [campanas, setCampanas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cargarCampanas();
  }, []);

  const cargarCampanas = async () => {
    try {
      const res = await api.get('/email/campanas');
      setCampanas(res.data.campanas || []);
    } catch (error) {
      console.error('Error cargando campañas:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudieron cargar las campañas'
      });
    } finally {
      setLoading(false);
    }
  };

  // ← ← ← NUEVO: Eliminar campaña
  const handleEliminar = async (id, nombre) => {
    const result = await Swal.fire({
      icon: 'warning',
      title: '¿Eliminar Campaña?',
      html: `¿Estás seguro de eliminar <strong>${nombre}</strong>?<br><br><span style="color: #ef4444;">⚠️ Esta acción no se puede deshacer</span>`,
      showCancelButton: true,
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#64748b',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });

    if (!result.isConfirmed) return;

    try {
      await api.delete(`/email/campanas/${id}`);

      Swal.fire({
        icon: 'success',
        title: '✅ Eliminada',
        text: 'La campaña ha sido eliminada',
        timer: 2000,
        showConfirmButton: false
      });

      cargarCampanas();
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo eliminar la campaña'
      });
    }
  };

  // ← ← ← NUEVO: Clonar campaña
  const handleClonar = async (id, nombre) => {
    try {
      const res = await api.post(`/email/campanas/${id}/clonar`, {});

      Swal.fire({
        icon: 'success',
        title: '✅ Campaña Clonada',
        html: `
          <p><strong>Original:</strong> ${nombre}</p>
          <p><strong>Nueva:</strong> ${res.data.campana.nombre}</p>
        `,
        timer: 2500,
        showConfirmButton: false
      });

      // Recargar lista para ver la nueva campaña
      cargarCampanas();
    } catch (error) {
      console.error('Error al clonar:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.error || 'No se pudo clonar la campaña'
      });
    }
  };

  // ← ← ← NUEVO: Ver detalle
  const handleVerDetalle = (id) => {
    navigate(`/email/campanas/${id}`);
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.loading}>Cargando campañas...</div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>📬 Campañas de Email</h1>
          <p style={styles.subtitle}>Gestiona y monitorea tus campañas de email marketing</p>
        </div>
        <Link to="/email/campanas/nueva" style={styles.btnPrimary}>
          ➕ Nueva Campaña
        </Link>
      </div>

      {/* Tabla */}
      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Nombre</th>
              <th style={styles.th}>Plantilla</th>
              <th style={styles.th}>Estado</th>
              <th style={styles.th}>Enviados</th>
              <th style={styles.th}>Fallidos</th>
              <th style={styles.th}>Fecha</th>
              <th style={styles.th}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {campanas.length > 0 ? (
              campanas.map(campana => (
                <tr key={campana.id} style={styles.tr}>
                  <td style={styles.td}>
                    <strong>{campana.nombre}</strong>
                  </td>
                  <td style={styles.td}>{campana.plantilla?.nombre || 'N/A'}</td>
                  <td style={styles.td}>
                    <span style={{
                      ...styles.badge,
                      ...(campana.estado === 'completado' ? styles.badgeSuccess :
                        campana.estado === 'enviando' ? styles.badgeInfo :
                        campana.estado === 'borrador' ? styles.badgeWarning :
                        styles.badgeDanger)
                    }}>
                      {campana.estado}
                    </span>
                  </td>
                  <td style={{ ...styles.td, color: '#10b981', fontWeight: '600' }}>
                    {campana.total_enviados || 0}
                  </td>
                  <td style={{ ...styles.td, color: '#ef4444', fontWeight: '600' }}>
                    {campana.total_fallidos || 0}
                  </td>
                  <td style={styles.td}>
                    {new Date(campana.created_at).toLocaleDateString('es-DO')}
                  </td>
                  <td style={styles.td}>
                    <div style={styles.actionButtons}>
                      <button
                        onClick={() => handleVerDetalle(campana.id)}
                        style={styles.btnAction}
                        title="Ver detalle"
                      >
                        👁️
                      </button>
                      
                      {campana.estado === 'completado' && (
                        <button
                          onClick={() => handleClonar(campana.id, campana.nombre)}
                          style={styles.btnClone}
                          title="Clonar campaña"
                        >
                          📋
                        </button>
                      )}
                      
                      <button
                        onClick={() => handleEliminar(campana.id, campana.nombre)}
                        style={styles.btnDelete}
                        title="Eliminar"
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" style={{ ...styles.td, textAlign: 'center', padding: '40px' }}>
                  <div style={styles.emptyState}>
                    <div style={styles.emptyIcon}>📧</div>
                    <p style={styles.emptyText}>No hay campañas registradas</p>
                    <Link to="/email/campanas/nueva" style={styles.btnPrimary}>
                      Crear Primera Campaña
                    </Link>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// 🎨 ESTILOS
// ═══════════════════════════════════════════════════════════════════════════
const styles = {
  container: {
    minHeight: 'calc(100vh - 70px)',
    background: 'linear-gradient(180deg, #f0f9ff 0%, #e0f2fe 50%, #f0f9ff 100%)',
    padding: '24px 32px',
    fontFamily: "'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif"
  },
  loading: {
    textAlign: 'center',
    padding: '40px',
    fontSize: '16px',
    color: '#64748b'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    background: 'white',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '0 0 4px 0'
  },
  subtitle: {
    fontSize: '14px',
    color: '#64748b',
    margin: 0
  },
  btnPrimary: {
    padding: '12px 24px',
    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
    color: 'white',
    borderRadius: '8px',
    textDecoration: 'none',
    fontWeight: '600',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    boxShadow: '0 2px 8px rgba(59, 130, 246, 0.3)',
    transition: 'all 0.2s'
  },
  tableContainer: {
    background: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    overflow: 'hidden'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse'
  },
  th: {
    padding: '16px',
    textAlign: 'left',
    fontSize: '12px',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: '#374151',
    borderBottom: '2px solid #e5e7eb',
    backgroundColor: '#f9fafb'
  },
  td: {
    padding: '16px',
    borderBottom: '1px solid #e5e7eb',
    color: '#374151'
  },
  tr: {
    transition: 'background 0.2s'
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '6px 14px',
    fontSize: '11px',
    fontWeight: '700',
    borderRadius: '20px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  badgeSuccess: {
    backgroundColor: '#d1fae5',
    color: '#065f46'
  },
  badgeDanger: {
    backgroundColor: '#fee2e2',
    color: '#991b1b'
  },
  badgeInfo: {
    backgroundColor: '#dbeafe',
    color: '#1e40af'
  },
  badgeWarning: {
    backgroundColor: '#fef3c7',
    color: '#92400e'
  },
  actionButtons: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },
  btnAction: {
    padding: '8px 12px',
    background: '#dbeafe',
    color: '#1e40af',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '16px',
    transition: 'all 0.2s'
  },
  btnClone: {
    padding: '8px 12px',
    background: '#d1fae5',
    color: '#065f46',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '16px',
    transition: 'all 0.2s'
  },
  btnDelete: {
    padding: '8px 12px',
    background: '#fee2e2',
    color: '#ef4444',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '16px',
    transition: 'all 0.2s'
  },
  emptyState: {
    textAlign: 'center',
    padding: '20px'
  },
  emptyIcon: {
    fontSize: '48px',
    marginBottom: '16px',
    opacity: 0.5
  },
  emptyText: {
    fontSize: '16px',
    color: '#64748b',
    marginBottom: '20px'
  }
};

export default EmailCampaignList;